<h1>Select default columns</h1>
<div class="group">
    <div *ngFor="let col of columns" class="full">
        <common-form-checkbox
            [label]="col.name"
            [value]="getControl(col.value)?.value || false"
            (valueChange)="getControl(col.value).setValue($event)">
        </common-form-checkbox>
    </div>

    <div class="actions margin-top-10">
        <button mat-raised-button color="primary" class="main" (click)="submitForm()">
            Save
        </button>
        <button mat-button (click)="modal.response.emit(null)">
            Cancel
        </button>
    </div>
</div>